import { LEAD_SOURCE } from "../lib/enums";

export function isPublicDemoLead(lead) {
  return lead?.source === LEAD_SOURCE.DEMO_REQUEST;
}

export function getLeadInterestLabel(lead, labels) {
  const interest = lead?.interest;
  if (!interest) return "";
  return labels?.[interest] || "";
}

